module.exports = __webpack_public_path__ + "img/pk.5ba83e78.svg";